import type {AxiosInstance, AxiosPromise, AxiosRequestConfig} from 'axios';
import axios from 'axios';
import enviroment from './enviroments/enviroment';

export interface Client {
  execute(requestConfig: AxiosRequestConfig): AxiosPromise<any>;
}

class AxiosClient implements Client {
  private axiosInstance: AxiosInstance;

  constructor(apiKey: string,resType='json', contentType = 'application/json') {
    this.axiosInstance = axios.create({
      headers: {
        Authorization: `Bearer ${apiKey}`,
        Accept: '*/*',
        'Content-Type': contentType,
        'responseType' : resType
      },

      // baseURL: 'https://api.sb.ronad.ir/api',  // SB
      baseURL: enviroment.base_url,
    });
  }

  execute(requestConfig: AxiosRequestConfig) {
    return this.axiosInstance(requestConfig);
  }
}

class VitrinClient implements Client {
  private axiosInstance: AxiosInstance;

  constructor(apiKey: string, contentType = 'application/json') {
    this.axiosInstance = axios.create({
      headers: {
        Authorization: `Bearer ${apiKey}`,
        Accept: '*/*',
        'Content-Type': contentType,
      },

      baseURL: 'https://vitrine-api.qa.ronad.ir/api',
    });
  }

  execute(requestConfig: AxiosRequestConfig) {
    return this.axiosInstance(requestConfig);
  }
}

export {VitrinClient};

export default AxiosClient;
